import { DeviceTreeNode } from "@/model/data/deviceTree/DeviceTreeNode";
import { AxiosResponse } from "axios";
import { ServiceResponseData } from "../ServiceResponseData";

export class GetDeviceTreeResData extends ServiceResponseData {
    deviceTree: DeviceTreeNode[];

    constructor(response: AxiosResponse) {
        super(response);
        this.deviceTree = [];
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(nodes: any) {
        nodes.forEach((node) => {
            var parsedNode = DeviceTreeNode.staticParse(node);
            if (parsedNode) this.deviceTree.push(parsedNode);
        });
    }
}
